import script from "./NewsletterPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsletterPopup.vue?vue&type=script&setup=true&lang=ts"

import "./NewsletterPopup.vue?vue&type=style&index=0&id=2e34888c&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e34888c"]])

export default __exports__